// src/pages/PublicLanding.js
import React from 'react';
import { useMsal } from '@azure/msal-react';

const PublicLanding = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
        instance.loginRedirect({
            redirectStartPage: '/'
        });
    };

  return (
    <div style={{
      height: '100vh',
      backgroundImage: 'url(/logo/wallpaper.png)', // 🔁 Replace with your image path
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Top Nav with Rubix Logo */}
      <div style={{
        height: '64px',
        padding: '1rem 2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderBottom: '1px solid #ddd'
      }}>
        <img src="/logo/rubix-logo.svg" alt="Rubix Logo" style={{ height: '48px', marginRight:'1.2rem' }} />
        <span style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333' }}>
            Strategic Content Accelerator
        </span>
      </div>

      {/* Login Card */}
      <div style={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '2rem 3rem',
          borderRadius: '20px 0px 20px 0px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center'
        }}>
          <h2 style={{ marginBottom: '1rem' }}>Client Portal</h2>
          <p style={{ marginBottom: '2rem', color: '#666' }}>
            Log in with your Microsoft account to access campaign data and insights.
          </p>
          <button
            onClick={handleLogin}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#EA7400',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Sign In with Microsoft
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicLanding;